import React, {Component} from 'react';
import {Button, Form, Input, Segment,Image} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import ImageUploadDropzone from './image_upload_dropzone';

const uuidv1 = require('uuid/v1');

class AddNewReceipt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            receiptDesc: undefined,
            imageFile: undefined
        }
    }

    handleSubmit = () => {
        this.setState({isCreating:true});
        const newReceipt = {
            client_id: uuidv1(),
            description: this.state.receiptDesc,
            action: 'create',
            images: this.state.imageFile
        };
        this.props.addNewReceipt(newReceipt);
        this.refs.receiptDesc.value = "";
        this.setState({isCreating:false});
    };

    handleFile = (file) => {
        let fr = new FileReader();
        if (file) {
            fr.onload = (e) => {
                file['dataURL'] = e.target.result;
                const image = {
                    id: uuidv1(),
                    file: file,
                };
                setTimeout(() => {
                    this.setState({imageFile: image})
                }, 500)
            };
            fr.readAsDataURL(file);
        }
    };

    render() {
        return (<div className="pad-all add-receipt-segment">
            <Segment >
                <Form onSubmit={this.handleSubmit}>
                    <div style={{padding: "0 1%"}}>
                        <Form.Field>
                            <label>Receipt Description</label>
                            <textarea
                                placeholder='Receipt Description'
                                ref="receiptDesc"
                                rows='4'
                                required
                                onFocus={(e) => {
                                    this.setState({receiptDesc: e.target.value});
                                }}
                                onChange={(e) => {
                                    this.setState({receiptDesc: e.target.value});
                                }}
                            />

                        </Form.Field>
                        <Form.Field>
                            <label>Receipt Image </label>
                            {!this.state.imageFile &&   <ImageUploadDropzone handlerFunction={(file) => {this.handleFile(file)}}/>}
                            {this.state.imageFile && <Image size="small" onClick={()=>{this.setState({imageFile:undefined})}}src={this.state.imageFile["file"]["dataURL"]}></Image>}
                        </Form.Field>
                        <Button type="submit" content="Add New Receipt" primary/>
                    </div>
                </Form>
            </Segment></div>)
    }

}

export default ReportContainer(AddNewReceipt);


// WEBPACK FOOTER //
// ./src/views/report/add_new_receipt.js